import script from "./Nav.vue?vue&type=script&lang=ts&setup=true"
export * from "./Nav.vue?vue&type=script&lang=ts&setup=true"

import "./Nav.vue?vue&type=style&index=0&id=1958ef7c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1958ef7c"]])

export default __exports__